export default __webpack_public_path__ + "static/media/loader.37000a78.svg";